<template>
  <section class="not-found-page">
    <div class="not-found-content">
      <p class="eyebrow">404</p>
      <h2>Page not found</h2>
      <p>
        This route slipped out of the raid group. Return to the dashboard and keep tracking progress.
      </p>
      <div class="page-actions">
        <RouterLink class="btn" to="/raiding">
          <i class="fa-solid fa-shield-halved"></i>
          Go to raids
        </RouterLink>
        <RouterLink class="btn-outline" to="/mythic-plus">
          <i class="fa-solid fa-dungeon"></i>
          Dungeons
        </RouterLink>
        <RouterLink class="btn-outline" to="/favorites">
          <i class="fa-solid fa-star"></i>
          Favorites
        </RouterLink>
      </div>
    </div>

    <div class="not-found-art" aria-hidden="true">
      <img src="../assets/images/404.png" alt="" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotFoundView',
}
</script>
